<template>
    <span>
        <AdminDashboard v-if="user.role === 'admin'" />
        <BuilderDashboard v-else-if="user.role === 'builder'" />
        <PlatformDashboard v-else />
    </span>
</template>

<script>
import { mapState } from 'vuex';
import PlatformDashboard from '@/views/PlatformDashboard';
import AdminDashboard from '@/views/AdminDashboard';
import BuilderDashboard from '@/views/BuilderDashboard';

export default {
    components: {BuilderDashboard, AdminDashboard, PlatformDashboard },
    computed: {
        ...mapState('auth', ['user']),
    }
};
</script>
